import moment from "moment";
import { pattern } from "./utils";

export const patientFormRender = [
  {
    type: "text",
    name: "first_name",
    label: "First Name",
    fieldLabel: "first_name",
    required: true,
    infoText: "",
    autoFocus: true,
    rules: {
      required: "First Name is required",
      validate: (value) => {
        const trimmed = value?.trim();

        if (!trimmed) return "Whitespace is not allowed";
        if (!/^[A-Za-z]+$/.test(trimmed))
          return "*First Name must contain only letters";

        return true;
      },
    },
  },
  {
    type: "text",
    name: "last_name",
    required: true,
    label: "Last Name",
    infoText: "",
    fieldLabel: "last_name",
    rules: {
      required: "Last Name is required",
      validate: (value) => {
        const trimmed = value?.trim();

        if (!trimmed) return "Whitespace is not allowed";
        if (!/^[A-Za-z]+$/.test(trimmed))
          return "*Last Name must contain only letters";

        return true;
      },
    },
  },
  {
    item: [
      {
        type: "dropdown",
        name: "gender",
        options: [
          { label: "Male", value: "male" },
          { label: "Female", value: "female" },
        ],
        required: true,
        label: "Gender",
        fieldLabel: "gender",
        rules: {
          required: "Gender is required",
        },
      },
      {
        type: "calendar",
        name: "dob",
        label: "Date of Birth",
        required: true,
        fieldLabel: "dob",
        dataType: "date",
        maxDate: moment().subtract(1, "days")?._d,
        rules: {
          required: "Date of Birth is required",
        },
      },
    ],
  },
  {
    type: "text",
    name: "address",
    label: "Street Address",
    required: true,
    fieldLabel: "address",
    rules: {
      required: "Address is required",
      pattern: {
        value: pattern("address"),
        message: "*Special characters like , and /  are  accept",
      },
      validate: (value) => value.trim() !== "" || "Whitespace is not allowed",
    },
  },
  {
    item: [
      {
        type: "text",
        name: "city",
        label: "City",
        required: true,
        fieldLabel: "city",
        rules: {
          required: "City is required",
          pattern: {
            value: pattern("cities"),
            message: "*City Should only contain letters",
          },
          validate: (value) =>
            value.trim() !== "" || "Whitespace is not allowed",
        },
      },
      {
        type: "text",
        name: "district",
        label: "District",
        fieldLabel: "district",
        required: true,
        rules: {
          required: "District is required",
          pattern: {
            value: pattern("cities"),
            message: "*District Should only contain letters",
          },
          validate: (value) =>
            value.trim() !== "" || "Whitespace is not allowed",
        },
      },
    ],
  },
  {
    item: [
      {
        type: "text",
        name: "state",
        label: "State",
        required: true,
        fieldLabel: "state",
        rules: {
          required: "State is required",
          pattern: {
            value: pattern("cities"),
            message: "*State Should only contain letters",
          },
          validate: (value) =>
            value.trim() !== "" || "Whitespace is not allowed",
        },
      },
      {
        type: "text",
        name: "pincode",
        label: "Pincode",
        required: true,
        fieldLabel: "pincode",
        rules: {
          required: "Pincode is required",
          pattern: {
            value: pattern("pinCode"),
            message: "*Enter Valid pin code",
          },
          maxLength: {
            value: 6,
            message: "*Pin Code Should be in 6 Digit",
          },
          minLength: {
            value: 6,
            message: "*Pin Code Should be in 6 Digit",
          },
        },
      },
    ],
  },
  {
    type: "tel",

    name: "phone_no",
    label: "Phone Number",
    fieldLabel: "phone_no",
    autoComplete: "nope",
    rules: {
      pattern: {
        value: pattern("phoneNo"),
        message: "*Enter Valid Phone Number",
      },
      minLength: {
        value: 10,
        message: "*Min 10 digit have to added",
      },
      maxLength: {
        value: 10,
        message: "*Max 10 digit only allowed",
      },
    },
  },
  {
    type: "text",
    name: "aadhar_no",
    label: "Aadhaar Number",
    fieldLabel: "aadhar_no",
    infoText: "",
    rules: {
      pattern: {
        value: pattern("aadharNo"),
        message: "*Enter Valid Adhaar Number",
      },
      maxLength: {
        value: 12,
        message: "*Only 12 digit are allowed",
      },
      minLength: {
        value: 12,
        message: "*Min 12 digit have to added",
      },
    },
  },
  {
    type: "text",
    name: "health_insurance_card",
    label: "Aarogyasri Number",
    infoText: "",
    fieldLabel: "health_insurance_card",
    rules: {
      pattern: {
        value: pattern("aarogyasri"),
        message: "*Please Enter Valid Aarogyasri Number",
      },
      maxLength: {
        value: 11,
        message: "*Only 11 digit are allowed",
      },
      minLength: {
        value: 11,
        message: "*Min 11 digit have to added",
      },
    },
  },
  {
    type: "text",
    name: "ration_card_no",
    label: "Ration Card Number",
    infoText: "",
    fieldLabel: "ration_card_no",
    rules: {
      pattern: {
        value: pattern("rationCardNo"),
        message: "*Please Enter Valid Ration Card Number",
      },
      maxLength: {
        value: 11,
        message: "*Only 11 digit are allowed",
      },
      minLength: {
        value: 11,
        message: "*Min 11 digit have to added",
      },
    },
  },
];

export const nonRequirePatientListField = [
  "patient_id",
  "created_at",
  "updated_at",
  "created_by",
  "updated_by",
  "profile_picture",
  "first_name",
  "last_name",
  "ration_card_no",
  "health_insurance_card",
  "address",
  "district",
  "state",
  "city",
  "pincode",
  "is_active",
  "is_deleted",
];

export const nonRequireMedicalListField = [
  "medical_prescription_id",
  "created_at",
  "created_by",
  "updated_at",
  "updated_by",
  "patient_visit_id",
];

export const nonRequirePatienttransportationdetails = [
  "patient_visit_id",
  "status",
  "no_of_followup_calls",
  "transportation_date",
  "status",
  "no_of_followup_calls",
  "created_at",
  "updated_at",
  "created_by",
  "updated_by",
  "patient_transportation_details_id",
];

export const nonRequireVisitListField = [
  "attented_by",
  "created_at",
  "updated_at",
  "created_by",
  "updated_by",
  "camp_details_id",
  "patient_id",
  "patient_visit_id",
  "profile_picture",
  "first_name",
  "last_name",
  "ration_card_no",
  "health_insurance_card",
  "address",
  "district",
  "state",
  "city",
  "pincode",
];

export const profileFormRender = [
  {
    item: [
      {
        type: "text",
        name: "user_name",
        label: "Username",
        fieldLabel: "user_name",
        placeholder: "",
      },
      {
        type: "text",
        name: "address",
        label: "Street Address",
        fieldLabel: "address",
        placeholder: "Address",
        infoText: "",
      },
    ],
  },
  {
    item: [
      {
        type: "text",
        name: "email",
        label: "Email",
        placeholder: "john.doe@gmail.com",
        fieldLabel: "email",
      },
      {
        type: "text",
        name: "city",
        label: "City",
        placeholder: "City",
        infoText: "",
        fieldLabel: "city",
      },
    ],
  },
  {
    item: [
      {
        type: "text",
        name: "phone_no",
        label: "Phone Number",
        fieldLabel: "phone_no",
        autoComplete: "nope",
        placeholder: "+1 (917) 543-9876",
        rules: {
          pattern: {
            value: pattern("phoneNo"),
            message: "*Enter Valid Phone Number",
          },
          minLength: {
            value: 10,
            message: "*Min 10 digit have to added",
          },
          maxLength: {
            value: 10,
            message: "*Max 10 digit only allowed",
          },
        },
      },
      {
        type: "text",
        name: "district",
        label: "District",
        placeholder: "San Diego",
        fieldLabel: "district",
      },
    ],
  },
  {
    item: [
      {
        type: "text",
        name: "state",
        label: "State",
        placeholder: "California",
        fieldLabel: "state",
        class: "justify-content-end",
      },
    ],
  },
  {
    item: [
      {
        type: "text",
        name: "pincode",
        label: "Pincode",
        placeholder: "231465",
        fieldLabel: "pincode",
        class: "justify-content-end",
        rules: {
          required: "Pincode is required",
          pattern: {
            value: pattern("pinCode"),
            message: "*Enter Valid pin code",
          },
          maxLength: {
            value: 6,
            message: "*Pin Code Should be in 6 Digit",
          },
          minLength: {
            value: 6,
            message: "*Pin Code Should be in 6 Digit",
          },
        },
      },
    ],
  },
];

export const passwordFormRender = [
  {
    item: [
      {
        type: "password",
        name: "old_password",
        label: "Current Password",
        fieldLabel: "old_password",
        required: true,
        rules: {
          required: "Current Password is required",
        },
      },
    ],
  },
  {
    item: [
      {
        type: "password",
        name: "new_password",
        label: "New Password",
        fieldLabel: "new_password",
        required: true,
        rules: {
          required: "New Password is required",
        },
      },
      {
        type: "password",
        name: "confirm_password",
        label: "Confirm New Password",
        fieldLabel: "confirm_password",
        required: true,
        rules: {
          required: "Confirm Password is required",
        },
      },
    ],
  },
];

export const nonRequireLogisticsField = [
  "created_at",
  "created_by",
  "patient_id",
  "no_of_followup_calls",
  "patient_transportation_details_id",
  "patient_visit_id",
  "surgery_recommended",
  "updated_at",
  "updated_by",
];

export const addVisits = [
  {
    type: "calendar",
    name: "date",
    label: "Date",
    fieldLabel: "date",
    dataType: "date",
    minDate: new Date(),
    required: true,
    className: "calender-std-height",
    rules: {
      required: "Date is required",
    },
  },
  {
    type: "buttonGroup",
    name: "patientActions",
    buttons: [
      {
        type: "primarySuccessButton",
        label: "Search Patients",
        name: "searchPatients",
        onClick: "searchPatients",
      },
      {
        type: "primarySuccessButton",
        icon: "pi pi-plus",
        label: "Add Patient",
        name: "addPatient",
        onClick: "addPatient",
      },
    ],
  },
  {
    type: "text",
    name: "patient_name",
    label: "Patient Name",
    fieldLabel: "patient_name",
    placeholder: "Select a patient from search",
    disabled: true,
    required: true,
    rules: {
      required: "Patient name is required",
    },
  },
  {
    type: "dropdown",
    name: "purpose",
    options: [
      { label: "Initial Visit", value: 1 },
      { label: "7th Day Follow up", value: 2 },
      { label: "14th Day Follow up", value: 3 },
      { label: "40st Day Follow up", value: 4 },
    ],
    label: "Purpose",
    fieldLabel: "purpose",
    required: true,
    rules: {
      required: "Purpose is required",
    },
  },
  {
    type: "dropdown",
    name: "primary_visit_id",
    options: [],
    label: "Primary Visit ID",
    fieldLabel: "primary_visit_id",
    required: true,
    rules: {
      required: "Primary Visit ID is required",
    },
  },
  {
    type: "dropdown",
    name: "examined_by",
    options: [
      { label: "demouser", value: 1 },
      { label: "optometrist", value: 2 },
    ],
    label: "Examined By",
    fieldLabel: "examined_by",
    required: true,
    rules: {
      required: "Examined By is required",
    },
  },
];

export const addOrEditPatientVisit = [
  {
    type: "calendar",
    name: "date",
    label: "Date",
    fieldLabel: "date",
    dataType: "date",
    minDate: new Date(),
    className: "calender-std-height",
    rules: {
      required: "Date is required",
    },
  },

  {
    type: "text",
    name: "patient_name",
    label: "Patient Name",
    fieldLabel: "patient_name",
    placeholder: "Select a patient from search",
    disabled: true,
    rules: {
      required: "Patient name is required",
    },
  },
  {
    type: "dropdown",
    name: "purpose",
    options: [
      { label: "Initial Visit", value: 1 },
      { label: "7th Day Follow up", value: 2 },
      { label: "14th Day Follow up", value: 3 },
      { label: "40st Day Follow up", value: 4 },
    ],
    label: "Purpose",
    fieldLabel: "purpose",
    rules: {
      required: "Purpose is required",
    },
  },
  {
    type: "dropdown",
    name: "primary_visit_id",
    options: [],
    label: "Primary Visit ID",
    fieldLabel: "primary_visit_id",
    rules: {
      required: "Primary Visit ID is required",
    },
  },
  {
    type: "dropdown",
    name: "examined_by",
    options: [
      { label: "demouser", value: 1 },
      { label: "optometrist", value: 2 },
    ],
    label: "Examined By",
    fieldLabel: "examined_by",
    rules: {
      required: "Examined By is required",
    },
  },
];

export const addVisitsForPatient = [
  {
    type: "calendar",
    name: "date",
    label: "Date",
    fieldLabel: "date",
    dataType: "date",
    minDate: new Date(),
    className: "calender-std-height",
    rules: {
      required: "Date is required",
    },
  },
  {
    type: "dropdown",
    name: "purpose",
    options: [],
    label: "Purpose",
    fieldLabel: "purpose",
    required: true,
    rules: {
      required: "Purpose is required",
    },
  },
  {
    type: "dropdown",
    name: "primary_visit_id",
    options: [],
    label: "Primary Visit ID",
    required: true,
    fieldLabel: "primary_visit_id",
    rules: {
      required: "Primary Visit ID is required",
    },
  },
  {
    type: "dropdown",
    name: "examined_by",
    options: [],
    label: "Examined By",
    required: true,
    fieldLabel: "examined_by",
    rules: {
      required: "Examined By is required",
    },
  },
];

export const addPayment = [
  {
    type: "calendar",
    name: "payment_date",
    label: "Date",
    fieldLabel: "payment_date",
    dataType: "date",
    rules: {
      required: "Date is required",
    },
  },
  {
    type: "dropdown",
    name: "collectable_payment_description_id",
    options: [],
    label: "Invoice",
    fieldLabel: "collectable_payment_description_id",
    rules: {
      required: "Invoice is required",
    },
  },
  {
    type: "currency",
    name: "total_collectable_amount",
    disabled: true,
    label: "Invoice Amount",
    fieldLabel: "total_collectable_amount",
  },
  {
    type: "currency",
    name: "total_paid_amount",
    disabled: true,
    label: "Paid Amount",
    fieldLabel: "total_paid_amount",
  },
  {
    type: "currency",
    name: "total_balance_amount",
    disabled: true,
    label: "Balance Amount",
    fieldLabel: "total_balance_amount",
  },
  {
    type: "currency",
    name: "amount_paid",
    options: [],
    required: true,
    label: "Payment Amount",
    placeholder: "Enter value",
    fieldLabel: "amount_paid",
    rules: {
      required: "Payment amount is required",
    },
  },
];

export const visualHeading = ["TYPE", "SPH", "NECYLAR", "AXIS", "VISION"];

export const visualTable = [
  {
    "Vision Type": {
      name: "Distance",
    },
    Sph: {
      name: "Sph",
    },
    NeCylar: {
      name: "NeCylar",
    },
    Axis: {
      name: "Axis",
    },
    Vision: {
      name: "Vision",
    },
  },
  {
    "Vision Type": {
      name: "Near",
    },
    Sph: {
      name: "Sph",
    },
    NeCylar: {
      name: "NeCylar",
    },
    Axis: {
      name: "Axis",
    },
    Vision: {
      name: "Vision",
    },
  },
];

export const userFormRender = [
  {
    type: "text",
    name: "first_name",
    required: true,
    label: "First Name",
    infoText: "",
    fieldLabel: "first_name",
    autoFocus: true,
    rules: {
      required: "First Name is required",
      validate: (value) => {
        const trimmed = value.trim();

        if (!trimmed) return "Whitespace is not allowed";
        if (!/^[A-Za-z]+$/.test(trimmed))
          return "*First Name must contain only letters";
        return true;
      },
    },
  },
  {
    type: "text",
    name: "last_name",
    label: "Last Name",
    fieldLabel: "last_name",
    required: true,
    rules: {
      required: "Last Name is required",
      validate: (value) => {
        const trimmed = value.trim();

        if (!trimmed) return "Whitespace is not allowed";
        if (!/^[A-Za-z]+$/.test(trimmed))
          return "*Last Name must contain only letters";

        return true;
      },
    },
  },
  {
    type: "text",
    name: "user_name",
    label: "Username",
    fieldLabel: "user_name",
    required: true,
    rules: {
      required: "Username is required",
    },
  },
  {
    type: "text",
    name: "email",
    label: "Email",
    fieldLabel: "email",
    required: true,
    rules: {
      required: "Email is required",
      pattern: {
        value: pattern("email"),
        message: "*Enter Valid Email",
      },
    },
  },
  {
    type: "password",
    name: "password",
    label: "Password",
    fieldLabel: "password",
    autoComplete: "new-password",
    required: true,

    rules: {
      minLength: {
        value: 8,
        message: "*Minimum 8 length",
      },
      required: "Password is required",
    },
  },
  {
    type: "tel",

    name: "phone_no",
    label: "Phone Number",
    fieldLabel: "phone_no",
    autoComplete: "nope",
    rules: {
      pattern: {
        value: pattern("phoneNo"),
        message: "*Enter Valid Phone Number",
      },
      minLength: {
        value: 10,
        message: "*Min 10 digit have to added",
      },
      maxLength: {
        value: 10,
        message: "*Max 10 digit only allowed",
      },
    },
  },
  {
    type: "text",
    name: "address",
    label: "Street Address",
    fieldLabel: "address",
    rules: {
      pattern: {
        value: pattern("address"),
        message: "*Special characters like , and /  are  accept",
      },
    },
  },
  {
    item: [
      {
        type: "text",
        name: "city",
        label: "City",
        fieldLabel: "city",
        rules: {
          pattern: {
            value: pattern("cities"),
            message: "*City Should only contain letters",
          },
          validate: (value) =>
            value?.trim() !== "" || "Whitespace is not allowed",
        },
      },
      {
        type: "text",
        name: "district",
        label: "District",
        fieldLabel: "district",
        rules: {
          pattern: {
            value: pattern("cities"),
            message: "*District Should only contain letters",
          },
          validate: (value) =>
            value?.trim() !== "" || "Whitespace is not allowed",
        },
      },
    ],
  },
  {
    item: [
      {
        type: "text",
        name: "state",
        label: "State",
        fieldLabel: "state",
        rules: {
          pattern: {
            value: pattern("cities"),
            message: "*State Should only contain letters",
          },
          validate: (value) =>
            value?.trim() !== "" || "Whitespace is not allowed",
        },
      },
      {
        type: "text",
        name: "pincode",
        label: "Pincode",
        fieldLabel: "pincode",
        rules: {
          pattern: {
            value: pattern("pinCode"),
            message: "*Enter Valid pin code",
          },
          maxLength: {
            value: 6,
            message: "*Pin Code Should be in 6 Digit",
          },
          minLength: {
            value: 6,
            message: "*Pin Code Should be in 6 Digit",
          },
        },
      },
    ],
  },
];

export const assignRoleFormRender = [
  {
    type: "dropdown",
    name: "camp",
    options: [],
    label: "Camp",
    fieldLabel: "camp",
    placeholder: "Select",
    required: true,
    rules: {
      required: "Camp is required",
    },
  },
  {
    type: "multiselect",
    name: "role",
    options: [],
    label: "Role",
    fieldLabel: "role",
    required: true,
    placeholder: "Type here",
    rules: {
      required: "Role is required",
    },
  },
];

export const rolesAndPermissionFormRender = [
  {
    type: "text",
    name: "permission_name",
    label: "Permission Name",
    fieldLabel: "permission_name",
  },
  {
    type: "password",
    name: "permission_ID",
    label: "Permission ID",
    fieldLabel: "permission_ID",
  },
  {
    type: "dropdown",
    name: "roles",
    options: [],
    label: "Roles",
    fieldLabel: "roles",
  },
];

export const addRoleFormRender = [
  {
    type: "text",
    name: "role_name",
    label: "Role Name",
    fieldLabel: "role_name",
  },
];

export const campFormRender = [
  {
    type: "text",
    name: "camp_name",
    label: "Camp Name",
    fieldLabel: "camp_name",
    autoFocus: true,
    required: true,
    rules: {
      required: "Camp Name is required"
    },
  },
  {
    type: "text",
    name: "description",
    label: "Description",
    fieldLabel: "description",
  },
  {
    type: "dropdown",
    name: "organization_id",
    label: "Organization",
    options: [],
    fieldLabel: "organization_id",
    required: true,
    rules: {
      required: "Organization is required"
    }
  },
  {
    type: "calendar",
    name: "start_date",
    label: "Start Date",
    fieldLabel: "start_date",
    dataType: "date",
    required: true,
    rules: {
      required: "Start Date is required"
    },
  },
  {
    type: "calendar",
    name: "end_date",
    label: "End Date",
    fieldLabel: "end_date",
    dataType: "date",
    required: true,
    rules: {
      required: "End Date is required"
    },
  },
  {
    type: "dropdown",
    name: "frequency",
    options: [],
    label: "Frequency",
    fieldLabel: "frequency",
  },
  {
    type: "dropdown",
    name: "camp_type_id",
    options: [],
    label: "Type",
    fieldLabel: "camp_type_id",
  },
  {
    type: "text",
    name: "address",
    label: "Street Address",
    fieldLabel: "address",
    rules: {
      pattern: {
        value: pattern("address"),
        message: "*Special characters like , and /  are  accept",
      },
    },
  },
  {
    item: [
      {
        type: "text",
        name: "city",
        label: "City",
        fieldLabel: "city",
        rules: {
          pattern: {
            value: pattern("cities"),
            message: "*City Should only contain letters",
          },
          validate: (value) =>
            value?.trim() !== "" || "Whitespace is not allowed",
        },
      },
      {
        type: "text",
        name: "district",
        label: "District",
        fieldLabel: "district",
        rules: {
          pattern: {
            value: pattern("cities"),
            message: "*District Should only contain letters",
          },
          validate: (value) =>
            value?.trim() !== "" || "Whitespace is not allowed",
        },
      },
    ],
  },
  {
    item: [
      {
        type: "text",
        name: "state",
        label: "State",
        fieldLabel: "state",
        rules: {
          pattern: {
            value: pattern("cities"),
            message: "*State Should only contain letters",
          },
          validate: (value) =>
            value?.trim() !== "" || "Whitespace is not allowed",
        },
      },
      {
        type: "text",
        name: "pincode",
        label: "Pincode",
        fieldLabel: "pincode",
        rules: {
          pattern: {
            value: pattern("pinCode"),
            message: "*Enter Valid pin code",
          },
          maxLength: {
            value: 6,
            message: "*Pin Code Should be in 6 Digit",
          },
          minLength: {
            value: 6,
            message: "*Pin Code Should be in 6 Digit",
          },
        },
      },
    ],
  },
  {
    type: "text",
    name: "contact_name",
    label: "Contact Name",
    fieldLabel: "contact_name",
  },
  {
    type: "text",
    name: "contact_number",
    label: "Contact Number",
    fieldLabel: "contact_number",
    rules: {
      pattern: {
        value: pattern("phoneNo"),
        message: "*Enter Valid Phone Number",
      },
      minLength: {
        value: 10,
        message: "*Min 10 digit have to added",
      },
      maxLength: {
        value: 10,
        message: "*Max 10 digit only allowed",
      },
    },
  },
];

export const organizationFormRender = [
  {
    type: "text",
    name: "organization_name",
    label: "Organization Name",
    required: true,
    fieldLabel: "organization_name",
    autoFocus: true,
    rules: { required: "Organization Name is required" }


  },
  {
    type: "text",
    name: "description",
    label: "Description",
    required: true,
    fieldLabel: "description",
    rules: {
      required: "Description is required"
    }
  },
  {
    type: "text",
    name: "address",
    label: "Street Address",
    fieldLabel: "address",
    rules: {
      pattern: {
        value: pattern("address"),
        message: "*Special characters like , and /  are  accept",
      },
    },
  },
  {
    item: [
      {
        type: "text",
        name: "city",
        label: "City",
        fieldLabel: "city",
        rules: {
          pattern: {
            value: pattern("cities"),
            message: "*City Should only contain letters",
          },
          validate: (value) =>
            value?.trim() !== "" || "Whitespace is not allowed",
        },
      },
      {
        type: "text",
        name: "district",
        label: "District",
        fieldLabel: "district",
        rules: {
          pattern: {
            value: pattern("cities"),
            message: "*District Should only contain letters",
          },
          validate: (value) =>
            value?.trim() !== "" || "Whitespace is not allowed",
        },
      },
    ],
  },
  {
    item: [
      {
        type: "text",
        name: "state",
        label: "State",
        fieldLabel: "state",
        rules: {
          pattern: {
            value: pattern("cities"),
            message: "*State Should only contain letters",
          },
          validate: (value) =>
            value?.trim() !== "" || "Whitespace is not allowed",
        },
      },
      {
        type: "text",
        name: "pin_code",
        label: "Pincode",
        fieldLabel: "pincode",
        rules: {
          pattern: {
            value: pattern("pinCode"),
            message: "*Enter Valid pin code",
          },
          maxLength: {
            value: 6,
            message: "*Pin Code Should be in 6 Digit",
          },
          minLength: {
            value: 6,
            message: "*Pin Code Should be in 6 Digit",
          },
        },
      },
    ],
  },
  {
    type: "text",
    name: "contact_person",
    label: "Contact Name",
    fieldLabel: "contact_person",
  },
  {
    type: "text",
    name: "contact_number",
    label: "Contact Phone Number",
    fieldLabel: "contact_number",
    rules: {
      pattern: {
        value: pattern("phoneNo"),
        message: "*Enter Valid Phone Number",
      },
      minLength: {
        value: 10,
        message: "*Min 10 digit have to added",
      },
      maxLength: {
        value: 10,
        message: "*Max 10 digit only allowed",
      },
    },
  },
];

export const donorFormRender = [
  {
    type: "text",
    name: "first_name",
    label: "First Name",
    fieldLabel: "first_name",
    required: true,
    infoText: "",
    autoFocus: true,
    rules: {
      required: "First Name is required",
      validate: (value) => {
        const trimmed = value?.trim();

        if (!trimmed) return "Whitespace is not allowed";
        if (!/^[A-Za-z]+$/.test(trimmed))
          return "*First Name must contain only letters";

        return true;
      },
    },
  },
  {
    type: "text",
    name: "last_name",
    required: true,
    label: "Last Name",
    infoText: "",
    fieldLabel: "last_name",
    rules: {
      required: "Last Name is required",
      validate: (value) => {
        const trimmed = value?.trim();

        if (!trimmed) return "Whitespace is not allowed";
        if (!/^[A-Za-z]+$/.test(trimmed))
          return "*Last Name must contain only letters";

        return true;
      },
    },
  },
  {
    type: "text",
    name: "donor_name",
    label: "Donor Name",
    required: true,
    fieldLabel: "donor_name",
    rules: {
      required: "Donor Name is required",
    },
  },
  {
    type: "text",
    name: "email",
    label: "Email",
    fieldLabel: "email",
    required: true,
    rules: {
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email address",
      },
    },
  },
  {
    type: "password",
    name: "password",
    label: "Password",
    fieldLabel: "password",
    autoComplete: "new-password",
    required: true,
    rules: {
      required: "Password is required",
      minLength: {
        value: 8,
        message: "*Minimum 8 length",
      },
    },
  },
  {
    type: "text",
    name: "phone_no",
    label: "Phone Number",
    fieldLabel: "phone_no",
    autoComplete: "nope",
    required: true,
    rules: {
      required: "Phone Number is required",
      pattern: {
        value: pattern("phoneNo"),
        message: "*Enter Valid Phone Number",
      },
      minLength: {
        value: 10,
        message: "*Min 10 digit have to added",
      },
      maxLength: {
        value: 10,
        message: "*Max 10 digit only allowed",
      },
    },
  },
  {
    type: "text",
    name: "address",
    label: "Street Address",
    fieldLabel: "address",
    rules: {
      pattern: {
        value: pattern("address"),
        message: "*Special characters like , and /  are  accept",
      },
    },
  },
  {
    item: [
      {
        type: "text",
        name: "city",
        label: "City",
        fieldLabel: "city",
        rules: {
          pattern: {
            value: pattern("cities"),
            message: "*City Should only contain letters",
          },
          validate: (value) =>
            value?.trim() !== "" || "Whitespace is not allowed",
        },
      },
      {
        type: "text",
        name: "district",
        label: "District",
        fieldLabel: "district",
        rules: {
          pattern: {
            value: pattern("cities"),
            message: "*District Should only contain letters",
          },
          validate: (value) =>
            value?.trim() !== "" || "Whitespace is not allowed",
        },
      },
    ],
  },
  {
    item: [
      {
        type: "text",
        name: "state",
        label: "State",
        fieldLabel: "state",
        rules: {
          pattern: {
            value: pattern("cities"),
            message: "*State Should only contain letters",
          },
          validate: (value) =>
            value?.trim() !== "" || "Whitespace is not allowed",
        },
      },
      {
        type: "text",
        name: "pincode",
        label: "Pincode",
        fieldLabel: "pincode",
        rules: {
          pattern: {
            value: pattern("pinCode"),
            message: "*Enter Valid pin code",
          },
          maxLength: {
            value: 6,
            message: "*Pin Code Should be in 6 Digit",
          },
          minLength: {
            value: 6,
            message: "*Pin Code Should be in 6 Digit",
          },
        },
      },
    ],
  },
];

export const DonorReportColumns = [
  {
    label: " Patient",
    name: "patient_name",
  },
  {
    label: " Patient Id",
    name: "patient_code",
  },
  {
    label: " Aadhaar No",
    name: "aadhar_no",
  },
  {
    label: " Dob",
    name: "dob",
  },
  {
    label: " Treatment Recommended",
    name: "treatment_recommended",
  },
];

export const CampsTableColumns = [
  {
    label: " User Name",
    name: "user_name",
  },
  {
    label: "Role Names",
    name: "role_names",
  },
  {
    label: "Email",
    name: "email",
  },
  {
    label: "Phone No",
    name: "phone_no",
  },
  {
    label: "Address",
    name: "address",
  },
];

export const OrganizationCampsColumns = [
  {
    label: "name",
    name: "camp_name",
  },
  {
    label: "id",
    name: "camp_code",
  },
  {
    label: "start",
    name: "start_date",
  },
  {
    label: "end",
    name: "end_date",
  },
  {
    label: "type",
    name: "camp_type_name",
  },
  {
    label: "freq",
    name: "frequency_name",
  },
  {
    label: "location",
    name: "city"
  }
]

export const TenantReportColumns = [
  {
    label: "Patient Name",
    name: "patient_name",
  },
  {
    label: "Patient Code",
    name: "patient_code",
  },
  {
    label: "Surgery Type",
    name: "surgery_type",
  },
  {
    label: "Total Amount",
    name: "total_amount",
  },
  {
    label: "Paid Amount",
    name: "paid_amount",
  },
  {
    label: "Balance Due",
    name: "balance_due",
  }
]

export const PatientVisitsColumns = [
  {
    label: "Visit Code",
    name: "patient_visit_code",
  },
  {
    label: "Visit Date",
    name: "visit_date",
  },
  {
    label: "Patient Name",
    name: "patient_name",
  },
  {
    label: "Patient ID",
    name: "patient_code",
  },
  {
    label: "Examiner",
    name: "examiner_name",
  },
  {
    label: "Purpose",
    name: "purpose",
  }
]

export const DonorreportColumns = [
  {
    label: "patient",
    name: "patient_name",
  },
  {
    label: "patient_id",
    name: "patient_code",
  },
  {
    label: "aadhaar",
    name: "aadhar_no",
  },
  {
    label: "gender",
    name: "gender",
  },
  {
    label: "treatment",
    name: "treatment_recommended",
  }
]

export const PatientReportListColumns = [
  {
    label: "patient name",
    name: "patient_name",
  },
  {
    label: "patient_id",
    name: "patient_code",
  },
  {
    label: "aadhar",
    name: "aadhar_no",
  },
  {
    label: "total",
    name: "total_amount",
  },
  {
    label: "paid amt",
    name: "total_paid",
  },
  {
    label: "balance",
    name: "total_due",
  },
  {
    label: "treatment type",
    name: "treatment_recommended",
  }
]

export const AllResourceListColumns = [
  {
    label: "user name",
    name: "user_name",
  },
  {
    label: "user_code",
    name: "user_code",
  },
  {
    label: "phone_no",
    name: "phone_no",
  }
]

export const LogisticsColumns = [
  {
    label: "patient visit code",
    name: "visit_code",
  },
  {
    label: "patient name",
    name: "patient_name",
  },
  {
    label: "patient id",
    name: "patient_code",
  },
  {
    label: "phone number",
    name: "phone_no",
  },
  {
    label: "surgery type",
    name: "status",
  },
  {
    label: "trans date",
    name: "transportation_date",
  },
  {
    label: "follow up calls",
    name: "no_of_followup_calls",
  },
]

export const RolesandPermissionsTableColumns = [
  {
    label: "User Name",
    name: "user_name",
  },
  {
    label: " Email",
    name: "email",
  },
  {
    label: " Phone No",
    name: "phone_no",
  },
  {
    label: " Address",
    name: "address",
  }
];

export const VisitsTableColumns = [
  {
    label: "date",
    name: "visit_date",
  },
  {
    label: " visit_id",
    name: "patient_visit_code",
  },
  {
    label: "examiner",
    name: "examiner_name",
  },
  {
    label: " examiner_id",
    name: "examiner_code",
  },
  {
    label: "Type",
    name: "purpose"
  }
];

export const MedicalPrescriptionsColumns = [
  {
    label: "name",
    name: "medicine_name",
  },
  {
    label: "dosage",
    name: "dosage",
  },
  {
    label: "type",
    name: "type",
  },
  {
    label: "frequency",
    name: "frequency",
  },
  {
    label: "route",
    name: "route",
  },
  {
    label: "period",
    name: "period",
  }
];

export const PatientListTableColumns = [
  {
    label: "patient",
    name: "patient_name",
  },
  {
    label: "patient id",
    name: "patient_code",
  },
  {
    label: "aadhaar no",
    name: "aadhar_no",
  },
  {
    label: "gender",
    name: "gender",
  },
  {
    label: "dob",
    name: "dob",
  },
  {
    label: "phone no",
    name: "phone_no",
  }
];

export const InvoiceListWithPatientColumns = [
  {
    label: "invoice id",
    name: "invoice_code",
  },
  {
    label: "patient name",
    name: "patient_name",
  },
  {
    label: "patient id",
    name: "patient_code",
  },
  {
    label: "Date",
    name: "InvoiceDate",
  },
  {
    label: "total amount",
    name: "total_collectable_amount",
  },
  {
    label: "amount paid",
    name: "total_paid_amount",
  },
  {
    label: "balance",
    name: "balance"
  }
];

export const InvoiceListWithoutPatientColumns = [
  {
    label: "invoice id",
    name: "invoice_code",
  },
  {
    label: "Date",
    name: "InvoiceDate",
  },
  {
    label: "total amount",
    name: "total_collectable_amount",
  },
  {
    label: "amount paid",
    name: "total_paid_amount",
  },
  {
    label: "balance",
    name: "balance"
  }
];

export const UsersTableColumns = [
  {
    label: "user name",
    name: "user_name",
  },
  {
    label: "email",
    name: "email",
  },
  {
    label: "phone no",
    name: "phone_no",
  },
  {
    label: "address",
    name: "address",
  }
];

export const CampsListTableColumns = [
  {
    label: "name",
    name: "camp_name",
  },
  {
    label: "id",
    name: "camp_code",
  },
  {
    label: "start",
    name: "start_date",
  },
  {
    label: "end",
    name: "end_date",
  },
  {
    label: "type",
    name: "camp_type_name",
  },
  {
    label: "freq",
    name: "frequency_name",
  },
  {
    label: "location",
    name: "city",
  }
];

export const OrganizationsTableColumns = [
  {
    label: "organization",
    name: "organization_name",
  },
  {
    label: "org id",
    name: "organization_code",
  },
  {
    label: "description",
    name: "description",
  },
  {
    label: "address",
    name: "address",
  },
  {
    label: "contact person",
    name: "contact_person",
  },
  {
    label: "contact no",
    name: "contact_number",
  }
];

export const PermissionsTableColumns = [
  {
    label: "permission name",
    name: "permission_name",
  },
  {
    label: "description",
    name: "permission_description",
  },
  {
    label: "role names",
    name: "role_names",
  }
];

export const DonorsTableColumns = [
  {
    label: "donor",
    name: "donor_name",
  },
  {
    label: "email",
    name: "email",
  },
  {
    label: "phone no",
    name: "phone_no",
  },
  {
    label: "total collectable amount",
    name: "total_collectable_amount",
  }
];

export const DonationTableColumns = [
  { name: "donation_code", label: "Donation Code" },
  { name: "created_at", label: "Date" },
  { name: "donation_amount", label: "Amount" },
];


export const primeReactConfig = {
  ripple: false,
  inputStyle: "outlined",
  hideOverlaysOnDocumentScrolling: true,
  autoZIndex: true,
};
